function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 0.887
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.577 24.999v27.186c.144 1.53 4.886 2.761 10.71 2.761 5.829 0 10.573-1.229 10.711-2.761.002-.023 0-.048 0-.07V24.998c-.138 1.532-4.882 2.761-10.71 2.761-5.825 0-10.567-1.23-10.711-2.761z",
  strokeWidth: 1.0000925
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.081 22.237c-4.347.358-7.504 1.422-7.504 2.69 0 1.565 4.795 2.833 10.71 2.833 5.916 0 10.711-1.268 10.711-2.832 0-1.222-2.942-2.229-7.046-2.62-1.238 2.221-2.77 3.456-3.383 3.54-.007.002-.028 0-.035 0H27.5c-.57 0-2.18-1.264-3.418-3.61z",
  strokeWidth: 1.0000925
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.67 15.49c0 6.598-4.209 10.358-5.187 10.358-.978 0-4.997-3.697-4.997-10.295s4.997-13.6 4.997-13.6S32.67 8.891 32.67 15.49z",
  strokeWidth: 1.0000925
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.193 20.712c0 3.277-1.335 5.145-1.645 5.145-.31 0-1.585-1.836-1.585-5.113s1.585-6.755 1.585-6.755 1.645 3.446 1.645 6.723z",
  strokeWidth: 1.0000925
}));

var SvgCandle = function SvgCandle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCandle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Candle.daa68c12.svg";
export { ForwardRef as ReactComponent };